import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "list-group list-group-flush" }
const _hoisted_4 = { class: "list-group-item" }
const _hoisted_5 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = {
  key: 0,
  class: "fa fa-user mr-1",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 1,
  class: "fa fa-folder mr-1",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  key: 2,
  class: "fa fa-book mr-1",
  "aria-hidden": "true"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 4 }
const _hoisted_12 = ["href"]

import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import { useSearchOrganizationUnitQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SearchOrganizationPage',
  setup(__props) {

    const route = useRoute()

    const tid = computed(() => Number(route.params.tid))
    const searchPhrase = computed(() => String(route.params.searchPhrase))

    const {
        modelSearchOrganizationUnitQueryV1: rm,
        runSearchOrganizationUnitQueryV1
    } = useSearchOrganizationUnitQueryV1(tid, searchPhrase)

    // ---------------- computed ----------------


    const results = computed(() =>
        rm.value?.Results ?? []
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Search results'
        runSearchOrganizationUnitQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Search results</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (r) => {
          return (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h5", _hoisted_6, [
                (r.Type=='User')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : (r.Type=='Workspace')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                    : (r.Type=='Portfolio')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                      : _createCommentVNode("v-if", true),
                (r.Url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      href: r.Url,
                      target: "_blank"
                    }, _toDisplayString(r.Type) + " " + _toDisplayString(r.Title), 9 /* TEXT, PROPS */, _hoisted_10))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(r.Type) + " " + _toDisplayString(r.Title), 1 /* TEXT */))
              ]),
              _createElementVNode("div", null, [
                (r.AdminUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: r.AdminUrl,
                      target: "_blank"
                    }, [
                      _cache[0] || (_cache[0] = _createElementVNode("span", null, "Manage", -1 /* CACHED */)),
                      _createCommentVNode("<i class=\"fa fa-cogs\" aria-hidden=\"true\"></i>")
                    ], 8 /* PROPS */, _hoisted_12))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("small", null, _toDisplayString(r.Details), 1 /* TEXT */)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */))
    ])
  ]))
}
}

})